import { Skeleton } from '@mui/material';
import { Breadcrumbs, SkeletonBreadcrumbs } from '@/components/presentation/Breadcrumbs';
import { WorkspaceObjectBreadcrumbs } from '@/components/Workspace/ObjectBreadcrumbs';
import { HomeBreadcrumb } from '@/components/Workspace/WorkspaceBreadcrumb';
import { useObjectBreadcrumbsContext } from '@/containers/WorkspaceObject/Context';
import styles from '@/screens/Transcript/style/Transcript.module.css';
import { useHasDataStewardRole } from '@/store/selectors';

type Props = unknown;

export const WorkspaceTranscriptBreadcrumbs = (props: Props) => {

  const breadcrumbs = useObjectBreadcrumbsContext();
  const hasDataStewardRole = useHasDataStewardRole();

  if (!breadcrumbs) {
    return (
      <SkeletonBreadcrumbs />
    );
  }

  return hasDataStewardRole
    ? <DataStewardBreadcrumbs />
    : <ObjectBreadcrumbs />;
};

const DataStewardBreadcrumbs = () => (
  <Breadcrumbs>
    <HomeBreadcrumb />
  </Breadcrumbs>
);

const ObjectBreadcrumbs = () => {

  const breadcrumbs = useObjectBreadcrumbsContext();

  return (
    <div className={styles.breadcrumbs}>
      <WorkspaceObjectBreadcrumbs items={breadcrumbs} />
    </div>
  );
};

WorkspaceTranscriptBreadcrumbs.displayName = 'Workspace.Transcript.Breadcrumbs';